import {GroupMember, User} from '../state-management/types';

export const check = (query?: string | number | null): boolean =>
  query !== null &&
  query !== undefined &&
  query !== -1 &&
  query !== '-1' &&
  query !== 'All' &&
  query !== 'undefined' &&
  query !== 'null' &&
  query !== '';

export const LIFECYCLE = check(window.LIFECYCLE)
  ? window.LIFECYCLE
  : 'local';

export const getCurrentUrl = (hostname: string): string => {
  if (hostname === 'localhost') return 'http://localhost:8000/'
  
  return encodeURI(`https://${window.location.hostname}/`);
};

export const CURRENT_URL = getCurrentUrl(window.location.hostname)

export const APP_CODE = check(window.APP_CODE)
  ? window.APP_CODE
  : 'test';

export const STATIC_BUCKET = check(window.STATIC_BUCKET)
  ? window.STATIC_BUCKET
  : `dev-${APP_CODE}-v2-web-static`

export const translateError = (error: string) => {
  console.log('ERROR MSG TO TRANSLATE:', error)
  
  const usernameExists = "UNIQUE constraint failed: users.username"
  if (error === usernameExists) return "Username already taken"
  
  const emailExists = "UNIQUE constraint failed: users.email"
  if (error === emailExists) return "Email already taken"
  
  const phoneExists = "UNIQUE constraint failed: users.phone"
  if (error === phoneExists) return "Phone number already used"
  
  const nanError = "payout: result="
  const nan2Error = "is not a number"
  if (error?.includes(nanError) && error?.includes(nan2Error)) return "Input isn't formatted properly. Make sure username comes before score"
  
  return error
}

export const getError = (data: any): string => {
  console.log('GETTING ERROR MSG:', data)

  if (data?.non_field_errors?.length) {
    return JSON.stringify(data.non_field_errors[0])
  }
  if (data?.error) return data.error
  if (data?.detail) return data.detail
  if (data?.new_password2) return data.new_password2
  if (data?.sport) return data.sport
  if (data?.community) return data.community

  return data
}

export const fixURI = (url: string): string => {
  let ret = url
  if (!url.includes('localhost')) ret = url.replace('http', 'https')
  return encodeURI(ret)
}


export const serializePlayers = (playerStr: string) =>  {
  console.log("PLAYER STRING", playerStr)
  
  const playerList: GroupMember[] = []
  
  playerStr.split(/\r?\n/).filter(Boolean).forEach((line: string, index: number) => {
    
    const fields = line.split(/\s+/)
    if (fields.length < 2) return

    const name = fields[0]
    const score = parseFloat(fields[1])
    let email = ''
    let phone = ''
  

    if (fields.length > 2) {
      if (String(fields[2]).includes('@')) {
        // eslint-disable-next-line prefer-destructuring
        email = fields[2]
        // eslint-disable-next-line prefer-destructuring
        if (fields.length > 3) phone = fields[3]
      }
      else {
        // eslint-disable-next-line prefer-destructuring
        phone = fields[2]
        // eslint-disable-next-line prefer-destructuring
        if (fields.length > 3) email = fields[3]
      }
    }
  
    const playerOwner: User = {
      id: -1,
      username: name,
      email,
      phone,
    }
    
    const member: GroupMember = {
      id: index,
      owner: playerOwner,
      score,
    }
    playerList.push(member)
  })
  
  return playerList
  
}


export const validateEmail = (emailStr: string) => {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailStr))
    return true
  return false
}

export const validatePhone = (phoneStr: string) => {
  if(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(phoneStr))
    return true
  return false
}

const getTimeDiffStr = (num: number, str: string) => {
  let returnStr = str
  if (num !== 1)
    returnStr += 's'
  return `${num} ${returnStr} ago`
}


export const getTimeDiff = (created: string) => {
  
  const dateCreated = new Date(created)
  const today = new Date()
  const diff = today.getTime() - dateCreated.getTime();
  
  let msec = diff;
  const yy = Math.floor(msec / 1000 / 60 / 60 / 24 / 30 / 365.25);
  msec -= yy * 1000 * 60 * 60 * 24 * 30 * 365.25;
  const mo = Math.floor(msec / 1000 / 60 / 60 / 24 / 30);
  msec -= mo * 1000 * 60 * 60 * 24 * 30;
  const dd = Math.floor(msec / 1000 / 60 / 60 / 24);
  msec -= dd * 1000 * 60 * 60 * 24;
  const hh = Math.floor(msec / 1000 / 60 / 60);
  msec -= hh * 1000 * 60 * 60;
  const mm = Math.floor(msec / 1000 / 60);
  msec -= mm * 1000 * 60;
  const ss = Math.floor(msec / 1000);
  
  if (yy > 0) {
    return getTimeDiffStr(yy, 'year')
  }
  if (mo > 0) {
    return getTimeDiffStr(mo, 'month')
  }
  if (dd > 0) {
    return getTimeDiffStr(dd, 'day')
  }
  if (hh > 1) {
    return getTimeDiffStr(hh, 'hour')
  }
  if (mm > 1) {
    return getTimeDiffStr(mm, 'minute')
  }
  return getTimeDiffStr(ss, 'second')
  
}